export const isAMEXCardNumber = val => {
  const tVal = String(val);
  return tVal[0] === '3' && (tVal[1] === '4' || tVal[1] === '7');
};
